import { FileCheck2 } from 'lucide-react';

import { Button } from '~shared/shadcn/ui/button';

interface RestoredCsvBannerProps {
  filename: string;
  rowCount: number;
  datasetLabel: string;
  onReplace?: () => void;
}

export function RestoredCsvBanner({
  filename,
  rowCount,
  datasetLabel,
  onReplace,
}: RestoredCsvBannerProps) {
  return (
    <div className='flex flex-wrap items-start justify-between gap-3 rounded-lg border border-primary/30 bg-primary/5 p-4'>
      <div className='flex min-w-0 gap-3'>
        <FileCheck2 className='mt-0.5 size-5 shrink-0 text-primary' />
        <div className='min-w-0'>
          <p className='font-medium'>CSV restored from your import session</p>
          <p className='mt-1 text-sm text-muted-foreground'>
            <span className='font-medium text-foreground'>{filename}</span>
            {' · '}
            {rowCount} {datasetLabel}
            {rowCount === 1 ? '' : 's'}
          </p>
        </div>
      </div>
      {onReplace && (
        <Button type='button' variant='outline' size='sm' onClick={onReplace}>
          Replace file
        </Button>
      )}
    </div>
  );
}

function headersFromRowKeys<T extends object>(rows: T[]): string[] {
  const first = rows[0];
  if (!first) return [];
  return Object.keys(first);
}

export { headersFromRowKeys };
